// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const ChatIcon: React.FunctionComponent<any> = ({ stroke = "#585858", fill = "none", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                fill={fill}
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 2h14a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-2v5l-6-5H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3z"
            />
        </SvgIcon>
    );
};
